module.exports = __webpack_public_path__ + "static/media/three-logo.d0814c96.svg";